import { createContext, Dispatch, ReactNode, RefObject, SetStateAction, useState } from 'react'
import { ProductMetafields } from '../../lib/types'

interface ProductLayoutContextProps {
  isTouched: boolean
  product: ProductMetafields
  productDetailsRef?: RefObject<HTMLDivElement>
  productSummaryHeight?: number
  setIsTouched: Dispatch<SetStateAction<boolean>>
  setProductDetailsRef: Dispatch<SetStateAction<RefObject<HTMLDivElement> | undefined>>
  setProductSummaryHeight: Dispatch<SetStateAction<number | undefined>>
}

export const ProductLayoutContext = createContext({} as ProductLayoutContextProps)

export const ProductLayoutProvider: React.FC<{ children: ReactNode; product: ProductMetafields }> = ({
  children,
  product,
}) => {
  const [productSummaryHeight, setProductSummaryHeight] = useState<number>()
  const [productDetailsRef, setProductDetailsRef] = useState<RefObject<HTMLDivElement>>()
  const [isTouched, setIsTouched] = useState(false)

  return (
    <ProductLayoutContext.Provider
      value={{
        isTouched,
        product,
        productDetailsRef,
        productSummaryHeight,
        setProductDetailsRef,
        setProductSummaryHeight,
        setIsTouched,
      }}>
      {children}
    </ProductLayoutContext.Provider>
  )
}
